import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class OrderStatusesService {
  fetchStoreWiseStatusList(storeId) {
    return axios.get(
      API_URL + `order-and-item-status/fetch-status-list/${storeId}`,
      {
        headers: authHeader(),
      }
    );
  }

  setStatus(data, id, recordType) {
    return axios.post(
      API_URL +
        `order-and-item-status/add-status-to-history/${id}/${recordType}`,
      data,
      {
        headers: authHeader(),
      }
    );
  }

  fetchStatusesHistory(ids) {
    return axios.post(
      API_URL + `order-and-item-status/fetch-statuses-history`,
      ids,
      {
        headers: authHeader(),
      }
    );
  }

  softDeleteStatus(id) {
    return axios.delete(API_URL + `order-and-item-status/soft-delete/${id}`, {
      headers: authHeader(),
    });
  }
}

export default new OrderStatusesService();
